import { useIsEnabled } from '@troon/analytics';
import { Link, Container, AccessLogo } from '@troon/ui';
import { Show } from 'solid-js';
import type { ComponentProps } from 'solid-js';

export function Footer() {
	const showConsent = useIsEnabled('cookie-consent');
	return (
		<div class="border-t border-neutral">
			<Container>
				<div class="flex flex-wrap items-center justify-between gap-4 py-6 md:gap-12 md:py-12">
					<nav>
						<ul class="flex flex-wrap gap-x-8 gap-y-2">
							<li class="basis-full sm:basis-auto">
								<Link href="/">
									<AccessLogo class="w-32" />
									<span class="sr-only">Golf with Access home</span>
								</Link>
							</li>
							<li>
								<NavLink href="/privacy-policy">Privacy Policy</NavLink>
							</li>
							<li>
								<NavLink href="/terms">Terms and Conditions</NavLink>
							</li>
							<li>
								<NavLink href="/contact">Contact us</NavLink>
							</li>
							<Show when={showConsent}>
								<li>
									<NavLink
										href="#"
										class="text-nowrap underline hover:text-brand-600"
										onClick={(e) => {
											e.preventDefault();
											typeof window.revisitCkyConsent === 'function' && window.revisitCkyConsent();
										}}
									>
										Cookie Settings
									</NavLink>
								</li>
							</Show>
						</ul>
					</nav>
					<p class="w-fit shrink-0 grow-0 text-sm">
						© {new Date().getFullYear()} <NavLink href="https://troon.com">Troon</NavLink>. All rights reserved.
					</p>
				</div>
			</Container>
		</div>
	);
}

declare global {
	interface Window {
		revisitCkyConsent?: () => void;
	}
}

function NavLink(props: ComponentProps<typeof Link>) {
	return (
		<Link href={props.href} class="text-sm hover:underline">
			{props.children}
		</Link>
	);
}
